import $ from 'jquery';

// Inspiration popup
// ******************************
//

function changeUrl(data) {
	let url = `/${data.id}/${data.slug}`;
	window.location.hash = url;
}



function formatData(data) {
    return {
        title: data.modalTitle,
        type: data.modalLinkType,
        image: data.modalImage,
        description: data.modalDescription,
        id: data.modalId,
        slug: data.modalSlug,
        url: data.inspUrl
    }
}



function buildPopup(htmlData) {
    const data = formatData(htmlData);
    changeUrl(data);
    const popup = $('#inspModal');
    // popup image
    popup.find('img').attr('src', data.image);
    // popup title
    popup.find('h4').text(data.title);
    //popup description
    popup.find('p').text(data.description);

    let fbLink = `https://www.facebook.com/sharer/sharer.php?u=${data.url}`;
    let twitLink = `https://twitter.com/home?status=${data.url}`;
    let pinLink = `https://pinterest.com/pin/create/button/?url=${data.url}&media=${data.image}&description=`;
    popup.find('.socialLinkFB').attr('href', fbLink);
    popup.find('.socialLinkTwit').attr('href', twitLink);
    popup.find('.socialLinkPin').attr('href', pinLink);
}



function openPopup(target) {
    target.magnificPopup({
        items: {
            src: '#inspModal',
            type: 'inline',
            midClick: true,
            removalDelay: 300,
            mainClass: 'mfp-fade'
        }
    }).magnificPopup('open');
}



// $card is the .insp-image-open-modal link wrapping a card's data attributes
function initPopup($card) {
    buildPopup($card.find('.inspiredItem').data());
    openPopup($card);
}



// Opens the popup for a #/<id>/<slug> link, the hash changeUrl() writes when a
// card is clicked. Only the first page of cards is rendered on load, so an item
// further down goes to its own page instead (an unknown slug redirects back to
// the gallery).
function openFromHash() {
	const match = window.location.hash.match(/^#\/(\d+)\/([\w-]+)/);
	if (!match) return;

	const [, id, slug] = match;
	const $card = $(`#inspirationLanding .inspiredItem[data-modal-id="${id}"]`).closest('.insp-image-open-modal');
	if ($card.length) {
		initPopup($card);
	} else {
		window.location.replace(`/inspiration/${slug}`);
	}
}


function attachHandlers() {
	if (!$('#inspirationLanding').length) return;

	$('#inspirationLanding').on('click', '.insp-image-open-modal', function(e) {
	    e.preventDefault();
	    initPopup($(this));
	});
	openFromHash();
}

export default attachHandlers;
